export default __webpack_public_path__ + "static/media/wallet_paiement_icon.a881dedd.svg";